<template>
  <section id="faq" class="tf-section faq style3 bg-st2 flat-accordion" data-aos="fade-up" data-aos-duration="800">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="tf-title m-b60">
                        <p class="h8 sub-title">FAQs</p>
                        <h4 class="title">Asking Yourself Something?</h4>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="flat-toggle box-text corner-box active">
                        <div class="h7 toggle-title active">Who is Hephaestus?</div>
                        <p class="toggle-content">
                            Hephaestus is the Greek god, referred to as god of fire, metalworking, stone masonry, forges, the art of sculpture, technology and blacksmiths. 
                            He was an undying builder. In our story, Hephaestus is Relsify.
                        </p>
                    </div>
                    <div class="flat-toggle box-text corner-box">
                        <div class="h7 toggle-title">Where is Mount Olympus & Lemnos?</div>
                        <p class="toggle-content">
                            Mount Olympus is said to be the abode of Hephaestus while Lemnos is his cult. 
                            Where Relsify and every tier-1 community member builds from is Mount Olympus and where we aggregate is Lemnos,
                             the Island of Lagos
                        </p>
                    </div>
                    <div class="flat-toggle box-text corner-box">
                        <div class="h7 toggle-title">What are Epithets of Hephaestus?</div>
                        <p class="toggle-content">
                            These are somewhat 'nicknames' of Hephaestus.
                             Aside his lame one (Amphigýeis) epithet, he was called ingenious (Polyphron), very famous (Agakyltos),
                             coppersmith (Khalkeús), renowned artificer (Klytotékhnēs) & shrewd (Polýmētis).
                             Each is used to uniquely represent each individual within our team
                        </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="flat-toggle box-text corner-box">
                        <div class="h7 toggle-title">What is SonsOfHephaestus?</div>
                        <p class="toggle-content">
                            It is a fictional name for the offspring of Hephaestus. 
                            Our aim was to have a name that effectively represents our story, in line with key historical facts. 
                        </p>
                    </div>
                    <div class="flat-toggle box-text corner-box">
                        <div class="h7 toggle-title">Why 10,500 SonsOfHephaestus?</div>
                        <p class="toggle-content">
                            Historically, Hephaestus had only 7 offspring, 
                            but we incorporated the idea of 1500 incarnate to expand the number such that 
                            it can represent the exact target number of our tier-1 community members. </p>
                    </div>
                    <div class="flat-toggle box-text corner-box">
                        <div class="h7 toggle-title">Why SonsOfHephaestus and not Daughters?</div>
                        <p class="toggle-content">
                            Although the offspring of Hephaestus were both male and female, 
                            we conceptualized SonsOfHephaestus from the Biblical concepts 
                            of referring to male and female as sons..</p>
                    </div>
                </div>       
            </div>
        </div>
    </section>

</template>

<script>
export default {
    name: 'FaqComponent'
}
</script>

<style>

</style>